import driverSlide1 from '../../assets/images/driver/driver-slide1.jpg';
import driverSlide2 from '../../assets/images/driver/driver-slide2.jpg';
import driverSlide3 from '../../assets/images/driver/driver-slide3.jpg';
import driverSlide4 from '../../assets/images/driver/driver-slide4.jpg';

const driverImages = [
  {
    src: driverSlide1,
    alt: "1",
    heading: "RC Medical",
    text: "Marka stworzona w odpowiedzi na potrzeby rynku podyktowane pandemią COVID-19.",
    button: "",
    link: "",
  },
  {
    src: driverSlide2,
    alt: "2",
    heading: "Dbamy o bezpieczenstwo",
    text: "Bezpieczeństwo naszych klientów to priorytet, dbamy aby nasze produkty były najwyższej jakości.",
    button: "",
    link: "",
  },
  {
    src: driverSlide3,
    alt: "3",
    heading: "Zadowoleni klienci",
    text: "Profesjonalna obsługa oraz indywidualne podejście do klienta gwarantuje sukces i długoterminową współpracę.",
    button: 'referencje',
    link: "/zaufali-nam",
  },
  {
    src: driverSlide4,
    alt: "4",
    heading: "Szeroki asortyment",
    text: "Nieustanne uzupełnianie asortymentu medycznego w odpowiedzi na potrzeby naszych klientów. ",
    button: "zobacz",
    link: "/produkty",
  },
];

export { driverImages };